import emafluorc from "../../../../assets/images/productos/Emafluorc/emaf.png";

import qr from "../../../../assets/images/QR Alberto Agliano.svg";

import pic1 from "../../../../assets/images/productos/Emafluorc/Mosaico - EM1.png";
import pic2 from "../../../../assets/images/productos/Emafluorc/Mosaico - EM2.png";
import pic3 from "../../../../assets/images/productos/Emafluorc/Mosaico - EM3.png";
import Producto from "../../../../components/producto";

import { useTranslation } from "react-i18next";

function Emafluorc() {

  const {t} = useTranslation()

  return (
    <Producto
      fotos={[pic1, pic2, pic3]}
      datosTabla1={[
        [t("tensionNominal"), "kV", "24 / 36"],
        [t("corrienteNominal"), "A", "800"],
        [t("corrienteBreveDuracion"), "kA", "25 / 20"],
        [t("corrienteDinamica"), "kA", "75 / 50"],
        [t("tensionDeImpulso"), "kV", "95 / 170"],
        [t("corrienteInterrupcionCargasActivas"), "A", "400 / 800"],
        [t("corrienteInterrupcionAnillo"), "A", "400 / 800"],
        [t("corrienteInterrupcionTransformador"), "A", "16"],
        [t("corrienteInterrupcionCables"), "A", "25"],
      ]}
      datosTabla2={[
        [t("modelo"), "", "17", "36"],
        [t("ancho"), "mm", "375 / 750", "750 / 1.000"],
        [t("alto"), "mm", "1.600 / 1.670", "2.200"],
        [t("profundidad"), "mm", "980 / 1.195", "1.405"],
      ]}
      nombreProducto={"Emafluorc"}
      fotoProducto={emafluorc}
      descripcionProducto={
        t("emafluorc.titulo_descripcion")
      }
      caracteristicas={[
        t("emafluorc.bullet1"),
        t("emafluorc.bullet2"),
        t("emafluorc.bullet3"),
        t("emafluorc.bullet4"),
      ]}
      vendedor={{
        nombre: "Alberto Agliano",
        telefono: "+54 9 11 5096-5598",
        mail: "apagliano@ema.com.ar",
        qr: qr,
      }}
      pathPdf={'/assets/docs/2025%20-%20EMAFLUORC.pdf'}
    />
  );
}

export default Emafluorc;
